import React, { useMemo, useState } from 'react';
import './floatingcontact.css';
import { openWhatsApp } from '../../services/contactChannels';

const contactActions = [
    {
        id: 'orcamento',
        icon: 'fa-file-text-o',
        label: 'Solicitar orçamento',
        message:
            'Olá, Nortesoft. Quero solicitar um orçamento para conhecer as soluções da empresa.',
    },
    {
        id: 'suporte',
        icon: 'fa-life-ring',
        label: 'Suporte técnico',
        message:
            'Olá, Nortesoft. Preciso de suporte técnico e gostaria de falar com a equipe.',
    },
    {
        id: 'comercial',
        icon: 'fa-comments-o',
        label: 'Contato comercial',
        message:
            'Olá, Nortesoft. Quero falar com o setor comercial para conhecer melhor as soluções.',
    },
];

const FloatingContactButton = () => {
    const [open, setOpen] = useState(false);

    const actions = useMemo(() => contactActions, []);

    return (
        <div className={`ns-float-contact ${open ? 'is-open' : ''}`}>
            <div className="ns-float-contact__panel" aria-hidden={!open}>
                <span className="ns-float-contact__title">Fale com a Nortesoft</span>

                {actions.map((action) => (
                    <button
                        type="button"
                        className="ns-float-contact__action"
                        key={action.id}
                        onClick={() => {
                            openWhatsApp(action.message);
                            setOpen(false);
                        }}
                    >
                        <i className={`fa ${action.icon}`} aria-hidden="true" />
                        <span>{action.label}</span>
                    </button>
                ))}
            </div>

            <button
                type="button"
                className="ns-float-contact__trigger"
                aria-label={open ? 'Fechar contatos' : 'Abrir contatos por WhatsApp'}
                onClick={() => setOpen((current) => !current)}
            >
                <i className={`fa ${open ? 'fa-times' : 'fa-whatsapp'}`} aria-hidden="true" />
            </button>
        </div>
    );
};

export default FloatingContactButton;
